@if (vm$ | async; as vm) {
  <div class="container">
    @if (!vm.progressError || vm.progressError.canRetry) {
      <div class="payment-container">
        <div class="payNowContainer">
          <div class="header">AMOUNT TO PAY NOW</div>
          <div class="amount" (click)="vm.canEditAmount ? onEditAmount() : null">
            <span>£{{ (vm.payNowAmount / 100).toFixed(2) }}</span>
            @if (vm.canEditAmount) {
              <ion-icon name="pencil-outline"></ion-icon>
            }
          </div>
          <div class="footer">
            <ion-icon name="information-circle-outline"></ion-icon
              ><span> {{ vm.canEditAmount ? 'Split payments allowed' : 'Single payment required' }}</span>
            </div>
          </div>
          <hr />
          <div id="paymentRequest" [style.display]="vm.ready ? null : 'none'">
            <div id="{{ paymentRequestButtonId }}"></div>
            <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="checkout">
              <p class="explainerText ion-text-center ion-text-wrap">
                <span>{{ vm.legend }}</span
                  >/<span id="generate">generate</span> your payment details below
                </p>
                <ion-item>
                  <label for="card-info">Card Info</label>
                  <div id="card-info" #cardInfo></div>
                  @if (vm.cardError) {
                    <div id="card-errors" role="alert">{{ vm.cardError }}</div>
                  }
                </ion-item>
                <ion-button type="submit">Pay £{{ vm.payNowAmount / 100 }}</ion-button>
              </form>
            </div>
          </div>
        }
        @if (vm.progressError) {
          <div class="outerPaymentErrorCont">
            <div class="paymentErrorCont">
              <p>{{ vm.progressError.message }}</p>
            </div>
          </div>
        }
      </div>
    }
